/**
 * Client-side helper that POSTs an HTML string to the llm-proxy
 * /api/html-to-pdf endpoint and returns the resulting PDF as an ArrayBuffer.
 */

import { authHeaders } from '../ai/authedFetch';

const LLM_BASE = process.env.REACT_APP_GPT_API
  ? process.env.REACT_APP_GPT_API.replace(/\/api\/chat$/, '')
  : 'http://localhost:8020';

export async function htmlToPdf(html, fetchFn = fetch) {
  // C3: the endpoint is verifyToken-gated; a bare POST 401s in prod and the
  // Download All zip silently degrades to .html files.
  const ah = await authHeaders();
  const res = await fetchFn(`${LLM_BASE}/api/html-to-pdf`, {
    method: 'POST',
    headers: { ...ah, 'Content-Type': 'application/json' },
    body: JSON.stringify({ html }),
  });
  if (!res.ok) throw new Error(`html-to-pdf failed: ${res.status}`);
  return res.arrayBuffer();
}
